import React, { useEffect, useState } from "react";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";

const RadioButton = ({
  id,
  value,
  name,
  title,
  onChange,
  defaultChecked,
  style,
  disabled,
}) => {
  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <input
        type="radio"
        disabled={disabled}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        style={{
          margin: "0px 10px",
        }}
      />
      <label htmlFor={id}>{title}</label>
    </div>
  );
};

function TransactionLimit({ clientData, isEditClicked, onChange }) {
  const [currentValue, setCurrentValue] = useState("rolling");
  const [minTransactionVolume, setMinTransactionVolume] = useState("");
  const [maxTransactionVolume, setMaxTransactionVolume] = useState("");
  const [minTransactionValue, setMinTransactionValue] = useState("");
  const [maxTransactionValue, setMaxTransactionValue] = useState("");
  const inputStyle = {
    alignSelf: "center",
    height: 40,
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    boxSizing: "border-box",
    width: "100%",
    backgroundColor: "#FFFFFF",
    color: "black",
    maxWidth: 500,
    minWidth: 250,
    width: 350,
  };
  const containerStyle = {
    padding: 0,
    maxWidth: 500,
    minWidth: 250,
    width: 350,
    height: "40px",
    border: "1px solid #CBCACA",
    borderRadius: "5px",
  };

  return (
    <div>
      <div
        style={{
          color: "#6C6B6B",
          margin: "3% 3% 0% 3%",
        }}
      >
        Set Transaction Volume Limit
      </div>

      <div
        style={{
          marginLeft: "2%",
          display: "flex",
          flexWrap: "wrap",
          gap: "0px 100px",
        }}
      >
        <div style={{ marginTop: 10 }}>
          <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
            Min Transaction Volume /per day
          </label>
          <CustomInput
            disabled={"disabled"}
            value={minTransactionVolume}
            onChange={(data) => setMinTransactionVolume(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="eg : 01 /per day"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
        <div style={{ marginTop: 10 }}>
          <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
            Max Transaction Volume /per day
          </label>
          <CustomInput
            disabled={"disabled"}
            value={maxTransactionVolume}
            onChange={(data) => setMaxTransactionVolume(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="eg : 8,00,000 /per day"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
      </div>

      <div
        style={{
          color: "#6C6B6B",
          margin: "3% 3% 0% 3%",
        }}
      >
        Set Transaction Value Limit
      </div>

      <div
        style={{
          marginLeft: "2%",
          display: "flex",
          flexWrap: "wrap",
          gap: "0px 100px",
        }}
      >
        <div style={{ marginTop: 10 }}>
          <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
            Min Transaction Volume /per day
          </label>
          <CustomInput
            disabled={"disabled"}
            value={minTransactionValue}
            onChange={(data) => setMinTransactionValue(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="eg : 01 /per day"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>

        <div style={{ marginTop: 10 }}>
          <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
            Max Transaction Volume /per day
          </label>
          <CustomInput
            disabled={"disabled"}
            value={maxTransactionValue}
            onChange={(data) => setMaxTransactionValue(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="eg : 8,00,000 /per day"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default TransactionLimit;
